<template>
    <v-dialog
        v-model="modalSelecaoAvaliador"
        max-width="400"
    >
        <v-card v-if="avaliadores[0]">
            <v-card-text>
                <v-select
                    style="max-width: 400px;"
                    v-model="selecaoAvaliador.co_usuario"
                    :items="avaliadores"
                    item-value="co_usuario"
                    item-text="no_nome"
                    label="Selecione um avaliador"
                />
            </v-card-text>

            <v-card-actions v-if="!isLoadingSelecao">
                <v-spacer />
                <v-btn
                    color="red darken-1"
                    text
                    flat
                    @click="fecharDialogoSelecaoAvaliador"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="green darken-1"
                    text
                    flat
                    :disabled="!selecaoAvaliador.co_usuario || selecaoAvaliador.co_usuario == 0"
                    @click="alterarAvaliador"
                >
                    Selecionar
                </v-btn>
            </v-card-actions>
            <v-card-actions v-else>
                <v-layout align-center justify-center>
                <v-progress-circular indeterminate/>
                </v-layout>
            </v-card-actions>
        </v-card>
        <v-card v-else>
            <v-layout align-center justify-center>
              <v-progress-circular indeterminate/>
            </v-layout>
        </v-card>
    </v-dialog>    
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'SelecaoAvaliadorDialog',
    props:{
        value: {
            type: Boolean,
            default: false,
        },
        propsAvaliador: {
            type: Object,
            default: () => {},
        },
        isLoading:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            modalSelecaoAvaliador: false,
            selecaoAvaliador:{
                co_usuario: 0,
                co_objeto: 0,
            },
            isLoadingSelecao: this.isLoading,
        }
    },
    filters:{},
    computed:{
        ...mapGetters({
            avaliadores: 'conta/usuarios'
        })
    },
    watch: {
        value(alternarModalAtivo){
            this.modalSelecaoAvaliador = alternarModalAtivo;
        },
        modalSelecaoAvaliador(alternarModalAtivo){
            this.$emit('input', alternarModalAtivo);
            if(this.propsAvaliador){
                Object.assign(this.selecaoAvaliador, this.propsAvaliador);
            }
        },
        isLoading(alterarCarregamento){
            this.isLoadingSelecao = alterarCarregamento;
        }

    },
    methods: {
        ...mapActions({
            buscarAvaliadores: 'conta/buscarUsuariosAvaliadores',
        }),
        alterarAvaliador(){
            this.$emit('alterar', this.selecaoAvaliador);
        },
        fecharDialogoSelecaoAvaliador(){
            this.modalSelecaoAvaliador = false;
        }
    },
    mounted() {
        if(!this.avaliadores[0]){
            this.buscarAvaliadores();
        }
    },
}
</script>